import { v4 as uuidv4 } from 'uuid';

import { daysShort } from '../constants/timetable';
import { EventPeriod, EventSubtype } from '../interfaces/Periods';
import { getEventEndTimeValue, getTimeValue } from './eventTimes';

/**
 * Returns an event object with all the event info
 * This was made to directly pass day, startTime, endTime for creating events via link
 * @param name
 * @param location
 * @param description
 * @param color
 * @param day
 * @param startTime
 * @param endTime
 * @returns EventPeriod object
 */
export const createEventObj = (
  name: string,
  location: string,
  description: string,
  color: string,
  day: number,
  startTime: number,
  endTime: number,
  subtype: EventSubtype,
): EventPeriod => {
  const newEvent: EventPeriod = {
    type: 'event',
    subtype: subtype,
    event: {
      id: uuidv4(),
      name: name,
      location: location,
      description: description,
      color: color,
    },
    time: {
      day: day,
      start: startTime,
      end: endTime,
    },
  };

  return newEvent;
};

/**
 * Similar to the createEventObj function
 * except that it converts the type of day, startTime and endTime
 * @param name
 * @param location
 * @param description
 * @param color
 * @param day
 * @param startTime
 * @param endTime
 * @returns EventPeriod object
 */
export const parseAndCreateEventObj = (
  name: string,
  location: string,
  description: string,
  color: string,
  day: string,
  startTime: Date,
  endTime: Date,
  subtype: EventSubtype,
): EventPeriod => {
  const eventDay = daysShort.indexOf(day) + 1;
  const eventStart = getTimeValue(startTime);
  const eventEnd = getEventEndTimeValue(endTime);

  return createEventObj(name, location, description, color, eventDay, eventStart, eventEnd, subtype);
};
